module.exports = __webpack_public_path__ + "img/cloandflo.3888135a.png";